/* custom code start */
/*
  Holly wishlist — navigation heart feedback.
  When a product is added to favourites (any .holly-wishlist-button on PLP/PDP),
  play a heartbeat + glow effect on the navigation wishlist icon.

  The favourite action itself is handled by the holly-account app
  (hollyWishListButton). We don't touch it; we only read the button's
  data-favorite state on click. We listen in the CAPTURE phase so we read the
  state BEFORE the app toggles it: a button that is not yet favourited means the
  click is an "add", which is when we want the nav heart to react. Removing a
  favourite (data-favorite already "true") plays nothing.
*/
(function () {
  function getNavHeart() {
    return document.querySelector('.header__icon--wishlist');
  }

  function playPulse() {
    var heart = getNavHeart();
    if (!heart) return;
    // Restart the animation if it is mid-play (rapid successive adds).
    heart.classList.remove('holly-fav-pulse');
    void heart.offsetWidth; // force reflow so the animation can replay
    heart.classList.add('holly-fav-pulse');
  }

  // Clean up the class once the heartbeat finishes so it can replay next time.
  document.addEventListener('animationend', function (event) {
    if (event.animationName !== 'holly-fav-heartbeat') return;
    var heart = event.target.closest && event.target.closest('.header__icon--wishlist');
    if (heart) heart.classList.remove('holly-fav-pulse');
  });

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('.holly-wishlist-button');
      if (!button) return;
      // "true" means it is already favourited -> this click removes it -> no effect.
      if (button.getAttribute('data-favorite') === 'true') return;
      playPulse();
    },
    true // capture: run before the button's inline onclick toggles the state
  );
})();
/* custom code end */
